import { render, staticRenderFns } from "./AllergiesBase.vue?vue&type=template&id=109a4ee0"
import script from "./AllergiesBase.vue?vue&type=script&lang=js"
export * from "./AllergiesBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports